export default __webpack_public_path__ + "static/PromptIconFour-7806e4d9b2c49bcf4ebe692e23f141a6.png";